export type UserRole = string;

export const UserRole = {
	SuperAdmin: 'Super_Admin',

	ApimAdmin: 'APIM_Admin',

	CloudAccountAdmin: 'CloudAccount_Admin',
	CloudAccountUser: 'Cloud_Account_User',

	CloudGroupAdmin: 'Cloud_Group_Admin',

	DisconnectedSubscriptionRequestor: 'Disconnected_Subscription_Requestor',
	SubscriptionAdmin: 'Subscription_Admin',
	SubscriptionTechnicalReviewer: 'Subscription_Technical_Reviewer',
	ConnectedSubscriptionRequestor: 'Conn_Sub_User',

	PORReader: 'POR_Reader',
	SubToOnPremTechnicalReviewer: 'POR_SubToOnPrem_Technical_Reviewer',
	SubToInternetTechnicalReviewer: 'POR_SubToInternet_Technical_Reviewer',
	DNDRSubToInternetTechnicalReviewer: 'DNDR_SubToInternet_Technical_Reviewer',
	DNDRSubToInternetGatewayPolicyReviewer: 'DNDR_SubToInternet_GatewayPolicy_Reviewer',
	DNDRSubToInternetCyberReviewer: 'DNDR_SubToInternet_Cyber_Reviewer',

	DNDRTechnicalImplementer: 'DNDR_Technical_Implementer',
	DNDRNetSecReviewer: "DNDR_NetSec_Reviewer",
	DNDAdmin: 'DND_Admin',

	AWSPORReader: 'AWS_POR_Reader',
	AWSPORTechnicalImplementer: 'AWS_POR_Technical_Implementer',
	AWSPORCyberReviewer: 'AWS_POR_Cyber_Reviewer',
	AWSPORSolArqReviewer: 'AWS_POR_Sol_Arq_Reviewer',
	AWSPORTechnicalReviewer: 'AWS_POR_Technical_Reviewer',

	DNDRReader: 'DNDR_Reader',

	ReportingUser: 'Reporting_User',

	CapabilityManager: 'Capability_Manager',

	SSPDeveloper: 'SSP_Developer',
	
	OrgAdmins: 'Org_Admins',

	ADAppsUser: 'AD_Apps_User',

	PORToOnPremTechReviewer: 'POR_On-Prem_Technical_Reviewer',
	PORToOnPremTechImplementer: 'POR_On-Prem_Technical_Implementer',
	PORSubToInternetSolArqReviewer: "POR_SubToInternet_Sol_Arq_Reviewer",
	PORSubToInternetCyberReviewer: "POR_SubToInternet_Cyber_Reviewer",
	PORSubToOnPremSolArqReviewer: "POR_SubToOnPrem_Sol_Arq_Reviewer",
	PORSubToOnPremCyberReviewer: "POR_SubToOnPrem_Cyber_Reviewer",


	TAPReportUser: 'TAP_Report_User',

	ApprovalsViewer: 'Approvals_Viewer',

	SSManagementGroup:'SS_Management_Group'
};
